
export const useGoogleMaps = () => {
  const autocomplete = async (text) => {
    return await useFetch(`/api/autocomplete?text=${text}`)
  }

  const reverseGeocode = async (latlng) => {
    return await useFetch(`/api/geocode?latlng=${latlng}`)
  }
  
  return {
    autocomplete,
    reverseGeocode
  }
}